import { Loader2 } from 'lucide-react';

/**
 * PageLoader - Suspense fallback for lazy-loaded route components
 *
 * Provides a consistent loading state during route transitions
 * when using React.lazy() for code splitting.
 */
export function PageLoader() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
      <p className="text-sm text-ink-supporting">Loading...</p>
    </div>
  );
}

export default PageLoader;
